import { Button, colors, ProductLineTitle, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const ProductLineHeaderRowStyled = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  border-bottom: 1px solid ${colors.neutral[300]};
  padding-bottom: 1.6rem;
`;

export const ProductLineTitleStyled = styled(ProductLineTitle)`
  & > span {
    ${typography.bold[24]}
  }
`;

export const AddPlanButtonStyled = styled(Button)`
  margin-left: auto;
  max-width: 16rem;
  min-width: unset;

  ${breakpointsMQ4.md.down} {
    max-width: unset;
    width: 100%;
  }
`;
